/**
 * The backdrop of the dialog, closes the dialog on click
 */
export function DialogOverlay(props: { onClick: () => void }) {
  return <div aria-hidden data-testid="dialog-overlay" className="absolute inset-0" onClick={() => props.onClick()} />
}
